import { Transforms } from 'slate';
import { ReactEditor, useFocused, useReadOnly, useSelected } from 'slate-react';
import type { PlateElementProps } from 'platejs/react';
import { useEditorRef } from 'platejs/react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

import { Figure, Figcaption } from 'common/components/Figure';
import { Img } from 'common/components/Img';
import { Selectable } from 'common/components/Selectable';
import {
    asEditor,
    resolveContentUrl,
} from 'common/components/ContentEditor/utils/editorHelpers';

export const EditorImage = ({
    element,
    attributes,
    children,
    className,
}: PlateElementProps) => {
    const editor = useEditorRef();
    const focused = useFocused();
    const selected = useSelected();
    const readOnly = useReadOnly();

    const { url } = element as { url?: string };

    const image = <Img src={url ? resolveContentUrl(url) : ''} />;
    const elementPath = ReactEditor.findPath(
        editor as unknown as ReactEditor,
        element
    );

    const hasText =
        element.children?.length &&
        'text' in element.children[0] &&
        !!element.children[0].text;
    const hasCaption = !readOnly || (readOnly && hasText);

    return (
        <div {...attributes} className={className} data-slate-url={url}>
            <Figure>
                {!readOnly ? (
                    <Selectable
                        contentEditable={false}
                        selected={focused && selected}
                        onClick={() => {
                            Transforms.select(asEditor(editor), elementPath);
                        }}
                    >
                        {image}
                    </Selectable>
                ) : (
                    <Zoom zoomMargin={50}>{image}</Zoom>
                )}

                {hasCaption && <Figcaption>{children}</Figcaption>}
            </Figure>
        </div>
    );
};
